import { PolicyVehicleV2 } from "@hagerty/customer-insurance-gateway-client";

import { vehicles, revalVehicles, VehicleKey } from "../mockVehicles";
import { InsuranceOpsGetPolicyResponse } from "../../../types/responses";

export const getMockVehicles = (
  ...vehicleIds: VehicleKey[]
): PolicyVehicleV2[] =>
  vehicleIds.map((vehicleId, index) => {
    const vehicle = vehicles[vehicleId];

    return {
      id: index + 1,
      year: vehicle.year.toString(),
      make: vehicle.make,
      model: vehicle.model,
      value: vehicle.value,
      vin: vehicle.vin,
      hasIdCard: vehicle.hasIdCard !== undefined ? vehicle.hasIdCard : true,
    };
  });

type Vehicle = InsuranceOpsGetPolicyResponse["Vehicles"][number];

export const getMockRevalVehicles = (...vehicleIds: VehicleKey[]): Vehicle[] =>
  vehicleIds.map((vehicleId, index) => {
    const vehicle = revalVehicles[vehicleId];

    return {
      Id: vehicle.id,
      Year: vehicle.year,
      Make: { Key: 1, Value: vehicle.make },
      Model: { Key: 2, Value: vehicle.model },
      Value: vehicle.value,
      PolicyItemNumber: index + 1,
      VIN: vehicle.vin,
      HasIdCard: true,
    };
  });
